var map = {
	"./WhatsApp Image 2025-09-17 at 12.16.29 (15).jpeg": 7597,
	"./WhatsApp Image 2025-09-17 at 12.16.29 (17).jpeg": 5919,
	"./WhatsApp Image 2025-09-18 at 13.21.57 (3).jpeg": 2573,
	"./WhatsApp Image 2025-09-18 at 13.21.57 (4).jpeg": 2958,
	"./WhatsApp Image 2025-09-18 at 13.21.57 (6).jpeg": 5372,
	"./WhatsApp Image 2025-09-26 at 11.18.05 AM.jpeg": 2637
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8097;